/* eslint-disable no-compare-neg-zero */
/* eslint-disable func-names */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import ResizeObserver from 'react-resize-observer';
import { Formik, Form, Field } from 'formik';
import { useTheme } from 'emotion-theming';
import useCalendar from './hooks/useCalendar';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import Spinner from '../../../../shared/components/Spinner/Spinner';
import Input from '../../../../shared/_TBComponents/Input/index';
import SelectBox from '../../../../shared/_TBComponents/SelectBox';
import MultipleChoiceQuestionsFormInputs from './MultipleChoiceQuestionsFormInputs';
import { createQuestionForAccount, fetchQuestionsForAccount, setQuestionCount } from '../../ducks/calendarActions';
import { showErrorToast } from '../../../../shared/utils/toastManager';

const FormWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 24px;
  width: 88vw;
  max-width: 1000px;
`;

const SpinnerWrapper = styled('div')`
.spinner-container {
  min-height: 500px;
}
`;

const ButtonsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const SaveButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  margin-top: 6px
;  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  background: ${(props) => props.backgroundColor};
  color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  user-select: none;
  border: 1px solid ${(props) => props.backgroundColor};
  transition: ${TransitionGlobal};
  ${(props) => !props.disabled && 'cursor: pointer;'}
  ${(props) => !props.disabled && ':hover { opacity: 0.7; }'}
`;

const CancelButton = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  height: 32px;
  padding: 6px 16px 6px 16px;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  user-select: none;
  border: 2px solid ${({ theme }) => theme.colors.text};
  transition: ${TransitionGlobal};
  :hover {
    opacity: 0.7;
  }
`;

const NameAndTypeWrapper = styled('div')`
 display: flex;
 flex-wrap: wrap;
 gap: 16px;
`;

const StyledTextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  min-height: 82px !important;
  padding: 10px;
  font-size: 16px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 4px;
  font-family: 'Nunito Sans';
  color: ${({ theme }) => theme.colors.text};
  background: ${({ theme }) => theme.colors.surfaceInput};
  &:focus {
    outline: none;
    border-color: #ccc;
    box-shadow: none;
  }
  ::placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }
`;

const DescriptionContainer = styled('div')`
display: flex;
flex-direction: column;
height: 100%;
`;

const ThresholdsTextContainer = styled('div')`
display: flex;
gap: 4px;
flex-direction: column;
`;

const InputTypeMinAndMaxContainer = styled('div')`
display: flex;
gap: 16px;
flex-wrap: ${(props) => props.containerWidth < 570 && 'wrap'};
margin-bottom: ${(props) => props.addMarginBottom && '100px'};
`;

const ThresholdRow = styled('div')`
display: flex;
gap: 16px;
flex-wrap: wrap;
`;

const NewQuestionForm = ({ closeModal }) => {
  const dispatch = useDispatch();
  const {
    handleGetCreatNewQuestionFormValidationSchema,
    handleGetCustomSelectStylesForNewQuestionDropdown,
  } = useCalendar();
  const typeSelectRef = useRef(null);
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(null);
  const questionCount = useSelector((state) => state.calendar.data.questionCount);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const { colors } = useTheme();
  const accountCode = currentUser?.accountCode;

  const isSubmitDisabled = (errors, touched, isSubmitting) => {
    if ((Object.keys(errors).length > 0 && Object.keys(touched).length > 0) || Object.keys(touched).length === 0 || isSubmitting) {
      return true;
    }
    return false;
  };

  const handleMarkAllTouched = (formValues, setTouched) => {
    setTouched(
      Object.keys(formValues).reduce((acc, field) => {
        acc[field] = true;
        return acc;
      }, {}),
    );
  };

  const handleResetTouched = (setTouched) => {
    setTouched({});
  };

  const inputTypeOptions = (values) => ([
    {
      name: 'Range Slider',
      id: 0,
      includeCheckmark: values.inputType === 0,
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Input Box',
      id: 1,
      includeCheckmark: values.inputType === 1,
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Multiple Choice',
      id: 3,
      includeCheckmark: values.inputType === 3,
      checkmarkColor: colors.textTertiary,
    },
    {
      name: 'Yes/No',
      id: 2,
      includeCheckmark: values.inputType === 2,
      checkmarkColor: colors.textTertiary,
    },
  ]);

  return (
    <Formik
      initialValues={{
        name: '',
        abbreviation: '',
        description: '',
        inputType: 0,
        minimum: 0,
        maximum: 5,
        upperThreshold: null,
        lowerThreshold: null,
        choiceValue: '',
        choiceColor: '',
        choiceNumericalWeight: '',
        choiceOrder: null,
        choicesArray: [],
      }}
      validationSchema={handleGetCreatNewQuestionFormValidationSchema()}
          onSubmit={(values, { setSubmitting, errors }) => {
            /** returns an updated formatted values object based on type */
            const baseValues = {
              title: values.name,
              abbr: values.abbreviation,
              description: values.description,
              inputType: values.inputType,
              minRangeValue: values.inputType === 0 ? parseInt(values.minimum, 10) : null,
              maxRangeValue: values.inputType === 0 ? parseInt(values.maximum, 10) : null,
              thresholdLowerLimit: values.lowerThreshold ? parseInt(values.lowerThreshold, 10) : null,
              thresholdUpperLimit: values.lowerThreshold ? parseInt(values.upperThreshold, 10) : null,
              choices: values.choicesArray,
            };

            /** Build and return the final object, excluding any properties with empty values */
            const updatedValues = Object.entries(baseValues).reduce((acc, [key, value]) => {
              if (
                value !== ''
                && value !== null
                && !(Array.isArray(value) && value.length === 0)
                && !(value && typeof value === 'object' && Object.keys(value).length === 0)
              ) {
                acc[key] = value;
              }
              return acc;
            }, {});

            if (!errors) {
              setSubmitting(true);
            }

            /** create new question for account with error handling */
            dispatch(createQuestionForAccount(accountCode, updatedValues, {
              onSuccess: (response) => {
                setSubmitting(false);
                /** add question to question count in create questionnaire form inputs */
                dispatch(setQuestionCount([
                  ...questionCount,
                  {
                    index: questionCount.length,
                    id: response.id,
                    isNullValue: false,
                    isVisible: true,
                    // isVisible: false, /** need this to handle fade in and out */
                  },
                ]));
                /** call to reload question with new question included */
                dispatch(fetchQuestionsForAccount(accountCode));
                closeModal();
              },
              onError: () => {
                setSubmitting(false);
                showErrorToast('Opps! Something went wrong. Unable to create new exercise.');
              },
            }));
          }}
          render={({
            errors,
            touched,
            handleSubmit,
            handleChange,
            values,
            setFieldValue,
            handleBlur,
            setFieldTouched,
            setFieldError,
            isSubmitting,
            validateForm,
            setTouched,
            setErrors,
          }) => (
            <Form>
              <FormWrapper>
                <Text fontWeight={700} fontSize='24px'> New Question</Text>
                {isSubmitting ? (
                  <SpinnerWrapper>
                    <Spinner />
                  </SpinnerWrapper>
                ) : (
                  <>
                    <ResizeObserver
                        onResize={(rect) => {
                          setContainerWidth(rect?.width);
                        }}
                    />
                    <NameAndTypeWrapper>
                      <Input
                          error={!!touched.name && !!errors.name}
                          errorMsg={errors.name}
                          fontSize='16px'
                          fontWeight={400}
                          height='38px'
                          label='Add New Question'
                          name='name'
                          onChange={(value) => {
                            handleChange(value);
                          }}
                          onBlur={handleBlur}
                          right='5px'
                          styledPropsLabel={{
                            fontSize: '16px',
                            fontWeight: 700,
                          }}
                          styledPropsWrapper={{
                            flex: 1,
                          }}
                          top='38px'
                          value={values.name}
                          width='100%'
                          placeholder={containerWidth < 308 ? 'Enter Question' : 'Enter question/feedback request'}
                      />
                      <div style={{ display: 'flex', minWidth: containerWidth < 527 ? '100%' : '200px' }} ref={typeSelectRef}>
                        <Input
                          textTransformUppercase
                          error={!!touched.abbreviation && !!errors.abbreviation}
                          errorMsg={errors.abbreviation}
                          fontSize='16px'
                          fontWeight={400}
                          height='38px'
                          label='Abbreviation'
                          name='abbreviation'
                          onChange={(value) => {
                            handleChange(value);
                          }}
                          onBlur={handleBlur}
                          right='5px'
                          styledPropsLabel={{
                            fontSize: '16px',
                            fontWeight: 700,
                          }}
                          styledPropsWrapper={{
                            flex: 1,
                          }}
                          top='38px'
                          value={values.abbreviation}
                          width='100%'
                          placeholder='i.e. ABR'
                        />
                      </div>
                    </NameAndTypeWrapper>
                    <DescriptionContainer>
                      <Text fontSize='16px' fontWeight={700}>
                        Description
                      </Text>
                      <Field
                        name='description'
                        className='form-control'
                        render={({ field }) => (
                          <StyledTextArea {...field} />
                        )}
                      />
                      {errors.description && touched.description && (
                        <Text color='#CC0404' fontSize='13px' fontWeight={700} style={{ marginTop: '5px' }}>{errors.description}</Text>
                      )}
                    </DescriptionContainer>
                    <InputTypeMinAndMaxContainer containerWidth={containerWidth} addMarginBottom={values.inputType === 1 || values.inputType === 2}>
                      <SelectBox
                        options={inputTypeOptions(values)}
                        value={inputTypeOptions(values).find((option) => option.id === values.inputType)}
                        onChangeFunction={(option) => {
                          setFieldValue('inputType', option.id);
                          handleResetTouched(setTouched);
                        }}
                        onBlur={() => setFieldTouched('inputType', true)}
                        error={!!touched.inputType && !!errors.inputType}
                        errorMsg={errors.inputType}
                        title='Input Type'
                        titleStyledProps={{ fontSize: '16px', fontWeight: 700 }}
                        customStyles={handleGetCustomSelectStylesForNewQuestionDropdown()}
                        isClearable={false}
                        styledProps={{ height: '', maxWidth: 468 }}
                        width='100%'
                        styledPropsInput={{
                          width: '100% !important',
                        }}
                      />
                      {values.inputType === 0 && (
                        <>
                          <Input
                            error={!!touched.minimum && !!errors.minimum}
                            errorMsg={errors.minimum}
                            fontSize='16px'
                            fontWeight={400}
                            height='38px'
                            label='Minimum'
                            name='minimum'
                            onChange={(value) => {
                              handleChange(value);
                            }}
                            onBlur={handleBlur}
                            right='5px'
                            styledPropsLabel={{
                              fontSize: '16px',
                              fontWeight: 700,
                            }}
                            styledPropsWrapper={{
                              flex: 1,
                              minWidth: containerWidth > 850 ? 226 : 120,
                            }}
                            top='38px'
                            value={values.minimum}
                            width='100%'
                          />
                          <Input
                            error={!!touched.maximum && !!errors.maximum}
                            errorMsg={errors.maximum}
                            fontSize='16px'
                            fontWeight={400}
                            height='38px'
                            label='Maximum'
                            name='maximum'
                            onChange={(value) => {
                              handleChange(value);
                            }}
                            onBlur={handleBlur}
                            right='5px'
                            styledPropsLabel={{
                              fontSize: '16px',
                              fontWeight: 700,
                            }}
                            styledPropsWrapper={{
                              flex: 1,
                              minWidth: containerWidth > 850 ? 226 : 120,
                            }}
                            top='38px'
                            value={values.maximum}
                            width='100%'
                          />
                        </>
                      )}
                    </InputTypeMinAndMaxContainer>
                    {values.inputType === 0 && (
                      <>
                        <ThresholdsTextContainer>
                          <Text fontSize='16px' fontWeight={700}>Thresholds (Optional)</Text>
                          <Text fontSize='16px' fontStyle='italic' color={colors.textSecondary}>Set an upper and a lower limit to report 3 separate segments (i.e. For the question “How many hours did you sleep?”, setting a Lower Threshold of 5  and an Upper Threshold of 7 will result in 3 segments: 1-5 hours will be  “unsatisfactory”, 5-7 hours as “satisfactory”, and 8+ hours as “excellent”).</Text>
                        </ThresholdsTextContainer>
                        <ThresholdRow>
                          <Input
                            error={!!touched.lowerThreshold && !!errors.lowerThreshold}
                            errorMsg={errors.lowerThreshold}
                            fontSize='16px'
                            fontWeight={400}
                            height='38px'
                            label='Lower Threshold'
                            name='lowerThreshold'
                            onChange={(value) => {
                              handleChange(value);
                            }}
                            onBlur={handleBlur}
                            right='5px'
                            styledPropsLabel={{
                              fontSize: '16px',
                              fontWeight: 700,
                            }}
                            styledPropsWrapper={{
                              flex: 1,
                              minWidth: containerWidth < 675 ? 136 : 226,
                              maxWidth: containerWidth > 516 && 226,
                            }}
                            top='38px'
                            value={values.lowerThreshold}
                            width='100%'
                          />
                          <Input
                            error={!!touched.upperThreshold && !!errors.upperThreshold}
                            errorMsg={errors.upperThreshold}
                            fontSize='16px'
                            fontWeight={400}
                            height='38px'
                            label='Upper Threshold'
                            name='upperThreshold'
                            onChange={(value) => {
                              handleChange(value);
                            }}
                            onBlur={handleBlur}
                            right='5px'
                            styledPropsLabel={{
                              fontSize: '16px',
                              fontWeight: 700,
                            }}
                            styledPropsWrapper={{
                              flex: 1,
                              minWidth: containerWidth < 675 ? 136 : 226,
                              maxWidth: containerWidth > 516 && 226,
                            }}
                            top='38px'
                            value={values.upperThreshold}
                            width='100%'
                          />
                        </ThresholdRow>
                      </>
                    )}
                    {values.inputType === 3 && (
                      <MultipleChoiceQuestionsFormInputs
                      errors={errors}
                      touched={touched}
                      setFieldValue={setFieldValue}
                      containerWidth={containerWidth}
                      handleBlur={handleBlur}
                      />
                    )}
                  </>
                )}
                <ButtonsContainer ref={containerRef}>
                  <SaveButton
                      onClick={() => {
                        if (isSubmitDisabled(errors, touched, isSubmitting)) {
                          handleMarkAllTouched(values, setTouched);
                          validateForm();
                        } else {
                          handleSubmit();
                        }
                      }}
                      backgroundColor={isSubmitDisabled(errors, touched, isSubmitting) ? colors.buttonDisabledBg : colors.buttonPrimaryBg}
                      disabled={isSubmitDisabled(errors, touched, isSubmitting)}
                  >
                    <Text color={colors.white} fontSize='16px' fontWeight={700}>SAVE AND ADD</Text>
                  </SaveButton>
                  <CancelButton onClick={() => {
                    closeModal();
                  }}
                  >
                    <Text fontSize='16px' fontWeight={700}>CANCEL</Text>
                  </CancelButton>
                </ButtonsContainer>
              </FormWrapper>
            </Form>
          )}
    />
  );
};

export default NewQuestionForm;
